// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__HI8qk","wrapper":"Policy_wrapper__fck0V","addr":"Policy_addr__RDk-6","points":"Policy_points__nU2hr","rules":"Policy_rules__F4FfY"};